import { z } from 'zod'
import { timestampSchema, uuidSchema } from './common.js'

export const kbLayerSchema = z.enum(['tenant', 'shared'])
export type KbLayer = z.infer<typeof kbLayerSchema>

export const knowledgeLibrarySchema = z.object({
  workspace_id: uuidSchema,
  label: z.string().min(1).max(200),
  created_by: uuidSchema,
  created_at: timestampSchema,
  updated_at: timestampSchema,
})
export type KnowledgeLibrary = z.infer<typeof knowledgeLibrarySchema>

export const knowledgeLibraryDeclareSchema = z.object({
  label: z.string().min(1).max(200),
})
export type KnowledgeLibraryDeclare = z.infer<typeof knowledgeLibraryDeclareSchema>

export const knowledgeLibraryGrantStatusSchema = z.enum(['active', 'revoked'])
export type KnowledgeLibraryGrantStatus = z.infer<typeof knowledgeLibraryGrantStatusSchema>

export const knowledgeLibraryGrantSchema = z.object({
  library_workspace_id: uuidSchema,
  consumer_workspace_id: uuidSchema,
  granted_by: uuidSchema,
  granted_at: timestampSchema,
  revoked_by: uuidSchema.nullable(),
  revoked_at: timestampSchema.nullable(),
  status: knowledgeLibraryGrantStatusSchema,
})
export type KnowledgeLibraryGrant = z.infer<typeof knowledgeLibraryGrantSchema>

export const knowledgeLibraryGrantCreateSchema = z.object({
  consumer_workspace_id: uuidSchema,
})
export type KnowledgeLibraryGrantCreate = z.infer<typeof knowledgeLibraryGrantCreateSchema>

export const knowledgeLibraryAccessSchema = z.object({
  library_workspace_id: uuidSchema,
  label: z.string(),
  granted_at: timestampSchema,
})
export type KnowledgeLibraryAccess = z.infer<typeof knowledgeLibraryAccessSchema>

export const vaultContextSnippetMetadataSchema = z.object({
  source_workspace_id: uuidSchema,
  kb_layer: kbLayerSchema,
  library_workspace_id: uuidSchema.nullable(),
})
export type VaultContextSnippetMetadata = z.infer<typeof vaultContextSnippetMetadataSchema>

export const vaultSourceReadSchema = z.object({
  id: uuidSchema,
  path: z.string(),
  content: z.string(),
  frontmatter: z.record(z.string(), z.unknown()),
  updated_at: timestampSchema,
  source_workspace_id: uuidSchema,
  kb_layer: kbLayerSchema,
  library_workspace_id: uuidSchema.nullable(),
})
export type VaultSourceRead = z.infer<typeof vaultSourceReadSchema>
